<template>
    <div class="h-100">
        <div v-if="!$store.getters.activeWebsite" class="d-flex flex-row step-card">
            <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-6 pa-0 h-100">
                    <div class="d-flex flex-column justify-space-around h-100">
                        <p class="ma-0 fw-400 fs-18">
                            You need to create website first.
                        </p>
                        <primary-button :to="'/websites/create'" :activeButton="true">Create first website</primary-button>
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-6 pa-0">
                    <v-img max-height="300px" max-width="100%" :src="$root.getSrc('/default/drop_icons/website_builder.svg')" contain></v-img>

                </div>
            </div>
        </div>
        <div v-else-if="$store.getters.activeWebsite && $store.getters.activeWebsite.amount_of_products == 0" class="d-flex flex-row step-card">
            <div class="row">
                <div class="col-md-6 pa-0 h-100">
                    <div class="d-flex flex-column justify-space-around h-100">
                        <p class="ma-0 fw-400 fs-18">
                            {{ isShopify ? 'You’re almost finished. To sell products on the Shopify start creating them on Drop.' : 'You’re almost finished. To sell products, start creating them on Drop.'}}

                        </p>
                        <primary-button :to="'/products/create'" :activeButton="true">Start creating</primary-button>
                    </div>
                </div>
                <div class="col-md-6 pa-0">
                    <v-img max-height="300px" max-width="100%" :src="$root.getSrc('/default/drop_icons/product_builder.svg')" contain></v-img>

                </div>
            </div>
        </div>
        <div class="d-flex align-center justify-center flex-column" style="height: 100%" v-else>
            <v-img max-height="96px" max-width="96px" :src="$root.getSrc('/default/drop_icons/tick.svg')" contain></v-img>
            <p class="ma-0 pt-5 fs-18 fw-400" v-if="isShopify">
                You’ve created {{$store.getters.activeWebsite.amount_of_products}} {{$store.getters.activeWebsite.amount_of_products ? 'products' : 'product'}}. Now you can connect shopify integration!
            </p>
            <p class="ma-0 pt-5 fs-18 fw-400" v-else>
                You’ve created {{$store.getters.activeWebsite.amount_of_products}} {{$store.getters.activeWebsite.amount_of_products ? 'products' : 'product'}}. Now you can start selling!
            </p>
            <p v-if="isShopify" class="ma-0 pt-5 fs-18 fw-400">
                You can go to next step.
            </p>

            <secondary-button v-if="isShopify" class="pt-5" @clickBtn="$emit('changeStep')" :activeButton="true">Next</secondary-button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['isShopify']
}
</script>
